import React from "react";
import tw from "tailwind-styled-components";
import { useFormik } from "formik";
import Loading from "../Loading";
import * as Yup from "yup";
import { InputGroup, Label, SubmitBtn } from "../Styles/InputStyles";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Model from "../Model";

const GstDetails =({
    setGstDetails,
    gstDetailsLoading,
    gstDetailsMutate,
    selectedData,
})=>{
    const SubmitHandler=(values)=>{
        gstDetailsMutate(values);
    }

    const formik = useFormik({
        initialValues:{
            id: selectedData?.id || "",
            clientId: selectedData?.clientId || "",
            gstNo: selectedData?.gstNo || "",
            isGstEnabled: selectedData?.isGstEnabled || 0,
            gstCharges: selectedData?.gstCharges || "",
            invoiceNoPrefix: selectedData?.invoiceNoPrefix || "",
            invoiceNo: selectedData?.invoiceNo || "",
        },

        validationSchema: Yup.object().shape({
            gstNo: Yup.string().required("Gst number required"),
            isGstEnabled: Yup.number().required("Select Status"),
            gstCharges: Yup.string().required("Gst Charges is required"),
            // invoiceNoPrefix: Yup.string().required("Invoice number prifix is required"),
            // invoiceNo: Yup.string().required("Invoice number is required"),
        }),

        onSubmit:SubmitHandler,
        enableReinitialize: true,
    })

    return(
        <Model width={`w-11/12 max-w-lg`} setOpenModel={setGstDetails}>
            {gstDetailsLoading ?(
                <div className="w-full h-full">
                    <Loading />
                </div>
            ):(
                <Wrapper>
                    <Title>Gst Details</Title>
                    <form onSubmit={formik.handleSubmit}>
                        <Wrapper>
                            <CombineInputGroup>
                                <InputGroup>
                                    <Label htmlFor="gstNo">Gst Number</Label>
                                    <FieldWrapper>
                                        <Input 
                                        name="gstNo"
                                        id="gstNo"
                                        value={formik.values.gstNo}
                                        onChange={formik.handleChange}
                                        />
                                        {formik.touched.gstNo && formik.errors.gstNo && (
                                            <p className="text-rose-600 text-sm">
                                                {formik.errors.gstNo}
                                            </p>
                                        )}
                                    </FieldWrapper>                                   
                                </InputGroup>
                                <InputGroup>
                                    <Label htmlFor="gstCharges">Gst Charges</Label>
                                    <FieldWrapper>
                                        <Input 
                                        name="gstCharges"
                                        id="gstCharges"
                                        value={formik.values.gstCharges}
                                        onChange={formik.handleChange}
                                        />
                                        {formik.touched.gstCharges && formik.errors.gstCharges && (
                                            <p className="text-rose-600 text-sm">
                                                {formik.errors.gstCharges}
                                            </p>
                                        )}
                                    </FieldWrapper>
                                </InputGroup>
                            </CombineInputGroup>

                            <CombineInputGroup>
                                <InputGroup>
                                    <Label htmlFor="invoiceNoPrefix">Invoice No Prefix</Label>
                                    <FieldWrapper>
                                        <Input 
                                        name="invoiceNoPrefix"
                                        id="invoiceNoPrefix"
                                        value={formik.values.invoiceNoPrefix}
                                        onChange={formik.handleChange}
                                        />
                                        {formik.touched.invoiceNoPrefix && formik.errors.invoiceNoPrefix && (
                                            <p className="text-rose-600 text-sm"> 
                                                {formik.errors.invoiceNoPrefix}
                                            </p>
                                        )}
                                    </FieldWrapper>
                                </InputGroup>
                                <InputGroup>
                                    <Label htmlFor="invoiceNo">Invoice Number</Label>
                                    <FieldWrapper>
                                        <Input 
                                        name="invoiceNo"
                                        id="invoiceNo"
                                        value={formik.values.invoiceNo}
                                        onChange={formik.handleChange}
                                        /> 
                                        {formik.touched.invoiceNo && formik.errors.invoiceNo && (
                                            <p className="text-rose-600 text-sm">
                                                {formik.errors.invoiceNo}
                                            </p>
                                        )}
                                    </FieldWrapper>
                                </InputGroup>
                            </CombineInputGroup>

                            <CombineInputGroup>
                                <InputGroup>
                                    <Label htmlFor="isGstEnabled">Is Gst Enabled</Label>
                                    <FieldWrapper $select={true}>
                                        <Select
                                          name="isGstEnabled"
                                          id="isGstEnabled"
                                          value={formik.values.isGstEnabled}
                                          onChange={formik.handleChange}
                                          className="w-full pl-2"
                                          displayEmpty
                                        >
                                            <MenuItem value={0}>No</MenuItem>
                                            <MenuItem value={1}>Yes</MenuItem>
                                        </Select>
                                        {formik.touched.isGstEnabled && formik.errors.isGstEnabled ? (
                                        <p className="text-rose-600 text-sm">
                                            {formik.errors.isGstEnabled}
                                        </p>
                                        ) : null}
                                    </FieldWrapper>
                                </InputGroup>
                            </CombineInputGroup>

                        </Wrapper>
                        <BtnWrapper>
                            <SubmitBtn type="submit">Update</SubmitBtn>
                        </BtnWrapper>
                    </form>
                </Wrapper>
            )}

        </Model>
    )
}

const Wrapper = tw.div` px-1 space-y-4`;
const Title = tw.h2` text-lg md:text-xl lg:text-2xl text-gray-600 font-medium mb-6 text-center`;
const CombineInputGroup = tw.div`flex space-x-7`;
const FieldWrapper = tw.div`w-full`;
const Input = tw.input`truncate border border-gray-300 border-m rounded pl-2 focus:ring-1 focus:ring-sky-600 focus:border-sky-600 focus:outline-none duration-200`;
const BtnWrapper = tw.div`w-full flex items-center justify-center space-x-10 mt-8`;

export default GstDetails;